'use strict';

import React from 'react';
import FaAngleDoubleDown from 'react-icons/lib/fa/angle-double-down';

class Hero extends React.Component {
  render() {
    return (
      <section className="hero-component" id="inicio">
        {/* <img src="/static/images/hero-bg.svg" /> */}
        <div className="section-title">
          <img alt="Toc To Me" src='/static/images/toctome.svg'></img>
        </div>
        <div className="slogan title">
          Apostamos numa relação de proximidade possibilitando assim
          aos nossos clientes o crescimento dos seus negócios de
          forma contínua e sustentada.
        </div>
        {/* <a className="scroll-cta" href="#servicos">
          <FaAngleDoubleDown />
        </a> */}
      </section>
    );
  }
}

Hero.displayName = 'Hero';

// Uncomment properties you need
// Footer.propTypes = {};
// Footer.defaultProps = {};

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero.js